import { IDettaglio } from "../../../../../interfaces/dettaglio/models";

export const matrixify = (arr: IDettaglio[], size: number): IDettaglio[][] =>
	Array.from(
		{ length: Math.ceil(arr.length / size) },
		(v, i) => arr.slice(i * size, i * size + size)
	);